import { forwardRef } from 'react';
import moment from 'moment-timezone'; // Needed for timezone config.
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HighchartsExporting from 'highcharts/modules/exporting';
import HighchartsExportData from 'highcharts/modules/export-data';

if (typeof Highcharts === 'object') {
  HighchartsExporting(Highcharts);
  HighchartsExportData(Highcharts);
}

export const TimeSeriesGraph = forwardRef(({ options, data, timezone, type }, ref) => {
  const opts = {
    title: {
      text: undefined,
    },
    exporting: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    ...options,
    chart: {
      ...options.chart,
      type,
    },
    series: data,
  };
  const globalOpts = {
    lang: {
      thousandsSep: ',',
    },
  };
  if (timezone) {
    window.moment = moment;
    globalOpts.time = {
      timezone,
    };
  }
  Highcharts.setOptions(globalOpts);
  return <HighchartsReact options={opts} ref={ref} containerProps={{ style: { width: '100%' } }} />;
});
